import React from "react";
import Text from "../Text";
import { Container } from "./styles";

type ErrorProps = {
	message: string;
};

const ErrorBlock = ({ message }: ErrorProps) => {
	return (
		<Container>
			<Text
				type="body3"
				style={{
					color: "#E86451",
					textAlign: "center",
					maxWidth: 300,
					alignSelf: "center",
				}}>
				{message}
			</Text>
		</Container>
	);
};

export default ErrorBlock;
